import { Form, Input, Modal, Select, Switch } from "antd";
import React, { useEffect, useState } from "react";
import { SwitchYesNo } from "~/components/form/SwitchYesNo.jsx";
import { $t } from "~/i18n.js";
import { AanmeldFormRegistrationList, isListFull } from "./AanmeldFormRegistrationList.jsx";

export const AanmeldForm = ({
  visible,
  kist_aanmelding,
  activeAanmelding,
  closeModal,
  saveAanmelding,
  activeDay,
  diensten,
  profile,
  types,
  vliegers,
  limit_signup_time,
  registration_lists,
  n_instructors,
  saveRegistration,
}) => {
  const [loading, setLoading] = useState(false);
  const [heleDag, setHeleDag] = useState(true);
  const [selectedListIds, setSelectedListIds] = useState([]);

  const [form] = Form.useForm();
  const overland = Form.useWatch("overland", form);
  const van = Form.useWatch("van", form);
  const tot = Form.useWatch("tot", form);
  const kist = Form.useWatch("kist", form);

  const isPrive = kist && kist.includes("privé");
  const hasDuty = diensten && diensten.some(d => d.user_id === profile.id);
  const enforceLimitTime = limit_signup_time && !isPrive && !hasDuty;

  useEffect(() => {
    if (overland && enforceLimitTime) {
      setHeleDag(true);
      form.setFieldsValue({ van: null, tot: null });
    }
  }, [overland, enforceLimitTime]);

  useEffect(() => {
    if (van && enforceLimitTime) {
      form.setFieldsValue({ tot: null });
    }
  }, [van, enforceLimitTime]);

  useEffect(() => {
    if (tot && enforceLimitTime) {
      form.setFieldsValue({ van: null });
    }
  }, [tot, enforceLimitTime]);

  useEffect(() => {
    setHeleDag(
      !(activeAanmelding && activeAanmelding.id) ||
        ((!activeAanmelding.van || activeAanmelding.van === "") &&
          (!activeAanmelding.tot || activeAanmelding.tot === "")),
    );
    form.resetFields();
  }, [
    setHeleDag,
    activeAanmelding,
    form,
    kist_aanmelding,
    activeDay.briefing_tijd,
  ]);

  const saveForm = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      console.log('form values', values, 'selected lists', selectedListIds);
      if ((!(activeAanmelding && activeAanmelding.id) || !activeAanmelding?.aangemeld) && selectedListIds.length > 0) {
        console.log('saving registrations for lists', selectedListIds);
      }
      const result = await saveAanmelding({
        action: activeAanmelding && activeAanmelding.id ? "wijzig" : "meld_aan",
        aanmelding_id: activeAanmelding.id || null,
        dag_id: activeDay.dag_id,
        datum: activeDay.datum,
        ...values,
        kist: values.kist ? values.kist.slice(0, 3) : [],
        van: !heleDag ? values.van : "",
        tot: !heleDag ? values.tot : "",
      });

      if (result) {
        // Save registrations for new signups or re-signups
        if ((!(activeAanmelding && activeAanmelding.id) || !activeAanmelding?.aangemeld) && selectedListIds.length > 0) {
          await Promise.all(
            selectedListIds.map((id) => {
              const list = registration_lists?.find((l) => l.id === id);
              const full = list ? isListFull(list, n_instructors) : false;
              return saveRegistration({
                dag_id: activeDay.dag_id,
                registration_list_id: id,
                action: full && list.has_waitinglist ? "add_to_waitinglist" : "register",
              });
            })
          );
        }
        closeModal();
        form.resetFields();
      }
      setLoading(false);
    } catch (info) {
      setLoading(false);
      console.log("Validate Failed:", info);
    }
  };

  return (
    <Modal
      title={
        activeAanmelding && activeAanmelding.id
          ? activeAanmelding.aangemeld
            ? $t("Wijzig aanmelding")
            : $t("Meld opnieuw aan")
          : $t("Meld je aan")
      }
      open={visible}
      confirmLoading={loading}
      onCancel={closeModal}
      onOk={saveForm}
      okText={$t("Opslaan")}
      cancelText={$t("Annuleren")}
    >
      <Form
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        name="addDay"
        preserve={false}
        initialValues={{
          checkstart: false,
          overland: false,
          van: activeAanmelding
            ? activeAanmelding.van
            : activeDay.briefing_tijd,
          tot: activeAanmelding ? activeAanmelding.tot : "",
          kist:
            activeAanmelding && activeAanmelding.kist
              ? activeAanmelding.kist
              : kist_aanmelding || [],
          ...(activeAanmelding || {}),
        }}
        requiredMark={false}
      >
        {profile.iedereen_aanmelden && vliegers && (
          <Form.Item label={$t("Lid")} name="lid">
            <Select
              showSearch
              filterOption={(input, option) =>
                option &&
                option.children &&
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              placeholder={$t("Selecteer lid om aan te melden")}
            >
              {vliegers.map(
                (vlieger, key) =>
                  vlieger.id > 0 && (
                    <Select.Option value={vlieger.id} key={key}>
                      {vlieger.name}
                    </Select.Option>
                  ),
              )}
            </Select>
          </Form.Item>
        )}

        {activeDay.is_vliegend && profile.vliegt && (
          <Form.Item label={$t("Kist")} name="kist">
            <Select
              mode="multiple"
              placeholder={$t("Welke kisten wil je op vliegen? (max 3)")}
            >
              {types.map((type, key) => (
                <Select.Option value={type} key={key}>
                  {type}
                </Select.Option>
              ))}
              <Select.Option value="privé">{$t("privé")}</Select.Option>
            </Select>
          </Form.Item>
        )}

        {activeDay.is_vliegend && profile.is_instructeur && (
          <Form.Item
            label={$t("Instructie geven")}
            name="as_instructeur"
            valuePropName="checked"
            extra={$t("Beschikbaar voor instructie gedurende de dag.")}
          >
            <SwitchYesNo />
          </Form.Item>
        )}

        {activeDay.is_vliegend && profile.wijzig_sleep && (
          <Form.Item
            label={$t("Sleepvliegen")}
            name="as_sleepvlieger"
            valuePropName="checked"
            extra={$t("Beschikbaar als sleepvlieger")}
          >
            <SwitchYesNo />
          </Form.Item>
        )}

        {activeDay.is_vliegend && profile.group_keys?.indexOf("brevet") > 0 && (
          <Form.Item
            label={$t("EASA trainingsvlucht")}
            name="checkstart"
            valuePropName="checked"
          >
            <SwitchYesNo />
          </Form.Item>
        )}

        {activeDay.is_vliegend && profile.vliegt && (
          <Form.Item
            label={$t("Overland")}
            name="overland"
            valuePropName="checked"
            extra={$t("Wil graag overland vliegen")}
          >
            <SwitchYesNo />
          </Form.Item>
        )}

        <Form.Item
          label={$t("Hele dag")}
          extra={
            enforceLimitTime &&
            overland &&
            $t("Als je overland gaat ben je er de hele dag om te helpen.")
          }
        >
          <SwitchYesNo
            onChange={(checked) => setHeleDag(checked)}
            checked={heleDag}
            disabled={enforceLimitTime && overland}
          />
        </Form.Item>

        {!heleDag && (
          <Form.Item
            label={$t("Vanaf")}
            name="van"
            extra={enforceLimitTime && tot && $t("Je geeft aan eerder te vertrekken, dan ben je er vanaf het begin bij om te helpen.")}
          >
            <Input
              type="time"
              style={{ width: 120 }}
              placeholder="hh:mm"
              disabled={enforceLimitTime && !!tot}
              allowClear={true}
            />
          </Form.Item>
        )}

        {!heleDag && (
          <Form.Item
            label={$t("Tot")}
            name="tot"
            extra={enforceLimitTime && van && $t("Je geeft aan later te starten, dan blijf je tot het einde bij om te helpen.")}
          >
            <Input
              type="time"
              style={{ width: 120 }}
              placeholder="hh:mm"
              disabled={enforceLimitTime && !!van}
              allowClear={true}
            />
          </Form.Item>
        )}

        <Form.Item
          label={$t("Opmerking")}
          name="opmerking"
          rules={[
            {
              required: false,
              max: 500,
              message: $t("Maximaal ${c} characters", { c: 500 }),
            },
          ]}
        >
          <Input.TextArea rows={2} />
        </Form.Item>
      </Form>

      {(!(activeAanmelding && activeAanmelding.id) || !activeAanmelding?.aangemeld) && (
        <AanmeldFormRegistrationList
          key={activeAanmelding?.id ?? 'new'}
          registration_lists={registration_lists}
          profile={profile}
          n_instructors={n_instructors}
          onChange={setSelectedListIds}
        />
      )}
    </Modal>
  );
};
